import Container from '@mui/material/Container';
import { useEffect } from 'react';
import { updateTitle } from '../../util/title';
import './style.css';

const Page = ({ children, modifier, title }) => {

    const classes = [ 'coe__page' ];

    // update page title
    useEffect(() => {
        updateTitle( title );
    }, [ title ]);

    if( modifier ) classes.push( classes[ 0 ] + '--' + modifier );

    return (
        <Container className={ classes.join( ' ' ) }>
            { children }
        </Container>
    )
}

export default Page